import React, { useState } from 'react'
// React Router
import { useNavigate } from 'react-router-dom'
// Ant Design
import { Flex, Empty, Typography, Button, Popconfirm, DatePicker, message, Spin, Select, Modal, Avatar, List } from 'antd'
// Ant Design Icons
import { LeftOutlined, DeleteOutlined, EyeOutlined, NumberOutlined } from '@ant-design/icons'
// Layouts
import { Linea } from '../../Layout/GraphsData/Linea'
import { Pastel } from '../../Layout/GraphsData/Pastel'
import { Barras } from '../../Layout/GraphsData/Barras'
import { Dona } from '../../Layout/GraphsData/Dona'
import { Range } from '../../Layout/GraphsData/Range'
import { Card } from '../../Layout/GraphsData/Card'
// Axios
import axios from 'axios'
// Config
import config from '../../config'
import { getConfig } from '../../config'

export const ContentReport = ({t, select, setSelect, apiReports, changeGraph, setChangeGraph}) => {
    const [messageApi, contextHolder] = message.useMessage()
    const [rangeNotFound, setRangeNotFound] = useState(false)
    const [loading, setLoading] = useState(false)
    const [channel, setChannel] = useState("")
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate()

    function NoData() {
        return (
            <Flex justify="center" style={{ width: "100%", marginTop: "20px" }}>
                <Empty description={t("select_report")} />
            </Flex>
        )
    }

    

    function Report() {
        const { Title, Text } = Typography
        const { RangePicker } = DatePicker;

        let graph = null
        if(select.graph_type === "Lineas" || select.graph_type === "lineas") {
            graph = <Linea graph={select} />
        }
        else if(select.graph_type === "Dona" || select.graph_type === "dona") {
            graph = <Dona graph={select} />
        }
        else if(select.graph_type === "Barras" || select.graph_type === "barras") {
            graph = <Barras graph={select} />
        }
        else if(select.graph_type === "Medidor" || select.graph_type === "medidor") {
            graph = <Range graph={select} />
        }
        else if(select.graph_type === "Pastel" || select.graph_type === "pastel") {
            graph = <Pastel graph={select} />
        }
        else if(select.graph_type === "Card" || select.graph_type === "card") {
            graph = <Card graph={select} size={"lg"} />
        }

        const changeDate = async (dates, dateStrings) => {
            if (dateStrings) {
                setRangeNotFound(false)
                setLoading(true)
                const startDate = dateStrings[0].split("-").reverse().join("/");
                const endDate = dateStrings[1].split("-").reverse().join("/");
                
                try {
                    const res = await axios.post(config.urlApi + "/private/stats", {
                        report_id: select._id,
                        start_date: startDate,
                        end_date: endDate,
                    });
                    if(res.status === 200) {
                        setChangeGraph(true)
                        setLoading(false)
                        
                        if(res.data.data.searchFilters.logicOperator === "OPTION" || res.data.data.searchFilters.logicOperator === "OR") {
                            setSelect({
                                ...select,
                                fields: res.data.data.fields,
                                axis: res.data.data.axis,
                                title: res.data.data.title,
                                searchFilters: res.data.data.searchFilters,
                                customOperators: res.data.data.customOperators,
                                start_date: startDate,
                                end_date: endDate,
                                channel: res.data.data.searchFilters.values[0].value,
                            })
                            setChannel(res.data.data.searchFilters.values[0].value)
                        }
                        else {
                            setSelect({
                                ...select,
                                fields: res.data.data.fields,
                                axis: res.data.data.axis,
                                title: res.data.data.title,
                                searchFilters: res.data.data.searchFilters,
                                customOperators: res.data.data.customOperators,
                                start_date: startDate,
                                end_date: endDate,
                            })
                        }
                    }
                } 
                catch (error) {
                    if (error.status === 404) {
                        setRangeNotFound(true)
                    }
                    else if (error.status === 401) {
                        navigate("/")
                    }
                    else {
                        messageApi.error(t("error_filter_date"))
                    }
                    setLoading(false)
                }
            }
        };

        const getYearMonth = (date) => date.getFullYear() * 12 + date.getMonth();
        const disabled7DaysDate = (current, { from, type }) => {
            if (from) {
                const minDate = new Date(from);
                const maxDate = new Date(minDate);
                maxDate.setDate(minDate.getDate() + 6);

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                if (current > today) {
                    return true;
                }

                switch (type) {
                    case 'year':
                        return current.getFullYear() < minDate.getFullYear() || current.getFullYear() > maxDate.getFullYear();
                    case 'month':
                        return getYearMonth(current) < getYearMonth(minDate) || getYearMonth(current) > getYearMonth(maxDate);
                    default:
                        return current < minDate || current > maxDate;
                }
            }
            return false;
        };

        const onDelete = async() => {
            try {
                const res = await axios.delete(`${config.urlApi}/private/report/${select._id}`, {
                    withCredentials: true,
                })
                if(res.status === 200) {
                    messageApi.success(t("success_delete_report"))
                    apiReports()
                    setSelect({})
                }
            }
            catch (error) {
                if (error.status === 401) {
                    navigate("/")
                }
                else if (error.status === 404) {
                    messageApi.error(t("error_delete_report_not_found"))
                }
                else {
                    messageApi.error(t("error_delete_report"))
                }
            }
        }

        const onSelectChannel = (value) => {
            setChannel(value)
            setSelect({
                ...select,
                channel: value,
            })
        }

        const showModal = () => setIsModalOpen(true);
        const handleCancel = () => setIsModalOpen(false);

        return (
            <Flex vertical align="center" justify={changeGraph ? "space-evenly" : "flex-start"} style={{ width: "100%", height: "100%" }}>
                <Flex vertical align="center">
                    <Title level={3} style={{ width: "100%", textAlign: "center", marginBottom: "0", marginTop: !changeGraph && "30px", transition: ".4s all ease", color: getConfig("colorPrimario") }}>{select.report_name}</Title>
                    {changeGraph && <Text style={{ marginTop: "2px", fontSize: "15px" }}><span>{t("date")}</span>: {select.start_date} - {select.end_date}</Text>}
                    
                    {(changeGraph && (select.searchFilters.logicOperator==="OPTION" || select.searchFilters.logicOperator==="OR")) &&
                        <Select
                            style={{ width: "300px", marginTop: "5px" }}
                            onChange={onSelectChannel}
                            value={channel}
                            options={select.searchFilters.values.map(value => ({
                                label: value.value,
                                value: value.value,
                            }))}
                        />
                    }

                </Flex>

                {changeGraph
                    ? graph
                    : <RangePicker onChange={changeDate} disabledDate={disabled7DaysDate} style={{ width: "60%", marginTop: "20px" }} placeholder={[t("filter_datestart"), t("filter_dateend")]} />
                }

                {changeGraph &&
                    <Button onClick={showModal} ghost size="small" icon={<EyeOutlined />} style={{ position: "absolute", top: "10px", right: "0", textTransform: "uppercase", color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }}>{t("operation")}</Button>
                }
                
                {rangeNotFound && 
                    <Flex justify="center" style={{ width: "100%", marginTop: "20px" }}>
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("not_found_range_date")} />
                    </Flex>
                }

                {loading &&
                    <Flex justify="center" style={{ width: "100%", marginTop: "20px" }}>
                        <Spin size="large" style={{ color: getConfig("colorPrimario") }} />
                    </Flex>
                }

                <Modal title={t("operation")} open={isModalOpen} onCancel={handleCancel} footer={null}>
                    <List
                        itemLayout="horizontal"
                        dataSource={select.customOperators}
                        renderItem={item => (
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<Avatar icon={<NumberOutlined />} />}
                                    title={item.name}
                                    description={item.operation}
                                />
                            </List.Item>
                        )}
                    />
                </Modal>

                {!select.created_by_admin &&
                    <Popconfirm
                        title={t("delete_report")}
                        description={t("sure_delete")}
                        onConfirm={onDelete}
                        okText={t("txt_yes")}
                        cancelText="No"
                        placement="topLeft"
                        zIndex={999999}
                    >
                        <Button ghost size="large" shape="circle" icon={<DeleteOutlined />} style={{ position: "absolute", bottom: "20px", right: "0", color: "red", border: "1.5px solid red" }} />
                    </Popconfirm>
                }

                <Button onClick={changeGraph ? () => setChangeGraph(false) : () => setSelect({})} ghost shape="circle" icon={<LeftOutlined />} style={{ position: "absolute", top: "15px", left: "15px", color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }} />
            </Flex>
        )
    }



    return (
        <Flex style={{ position: "relative", width: "75%", height: "calc(100vh - 60px)" }}>
            {select.report_name
                ? <Report />
                : <NoData />
            }

            {contextHolder}
        </Flex>
    )
}
